import { createRoute } from '@tanstack/react-router'
import { UserRolesPage } from '@/features/users/pages/UserRolesPage'
import { Route as authenticatedRoute } from './route'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/roles',
  component: () => (
    <ProtectedRoute requiredRoles="admin">
      <UserRolesPage />
    </ProtectedRoute>
  ),
})
